import React from "react";
import { connect } from "react-redux";
import {
  Layout,
  Table,
  Button,
  Tooltip,
  Tag,
  Typography,
  Space,
  Row,
  Col,
  Alert,
} from "antd";
import {
  CloseCircleOutlined,
  DollarCircleOutlined,
  PlusCircleOutlined,
} from "@ant-design/icons";
import { getAllRefunds, finishRefunds } from "services/refund-service";
import {
  getLastBatch,
  closeLastBatch,
  openBatch,
} from "services/transfeera-service";
import { Header, FormatDate, FormatMoney } from "components";
import { formatDate } from "utils/index";
import { useNavigate } from "react-router-dom";
import _ from "lodash";

const { Footer, Content } = Layout;
const { Text } = Typography;

const mapStateToProps = (state) => ({
  login: state.authReducer.loginReducer,
});

const DataFetch = {
  data: [],
  loading: false,
};

const DataBatchFetch = {
  data: null,
  loading: true,
};

const RefundScreen = (props) => {
  const { login } = props;
  const [data, setData] = React.useState(DataFetch);
  const [batch, setBatch] = React.useState(DataBatchFetch);
  const navigate = useNavigate();

  const load = async () => {
    setData((x) => ({ ...x, loading: true }));
    const res = await getAllRefunds();
    setData({ data: res, loading: false });
  };

  const loadBatch = async () => {
    setBatch((x) => ({ ...x, loading: true }));
    const res = await getLastBatch();
    setBatch((x) => ({ loading: false, data: res ? res : null }));
  };

  const onCloseBatch = async () => {
    setBatch((x) => ({ ...x, loading: true }));
    await closeLastBatch();
    await loadBatch();
  };

  const onOpenBatch = async () => {
    setBatch((x) => ({ ...x, loading: true }));
    await openBatch();
    await loadBatch();
  };

  const onFinishRefunds = async () => {
    setData((x) => ({ ...x, loading: true }));
    const res = await finishRefunds();
    await load();
  };

  React.useEffect(() => {
    load();
    loadBatch();
  }, []);

  return (
    <Layout className="alymente-layout">
      <Header title="Reembolso">
        {/* {(login.company.master && !batch.loading) &&
                    <Row>
                        <Col>
                            {batch.data ?
                                <Alert message={`Lote: ${batch.data.batchId}`} type="success" showIcon />
                                :
                                <Alert message="Você não possui um lote aberto!" type="info" showIcon />
                            }
                        </Col>
                    </Row>
                } */}
      </Header>
      <Content>
        <Table
          scroll={{ x: login.company.master ? 2500 : 1500, y: 650 }}
          dataSource={data.data}
          loading={data.loading}
          pagination={false}
          bordered
        >
          <Table.Column
            fixed="left"
            width={40}
            align="center"
            title="Data"
            dataIndex="createdAt"
            key="createdAt"
            render={(value) => <FormatDate value={value} />}
          />

          <Table.Column
            fixed="left"
            width={110}
            title="Participante"
            dataIndex="employee"
            key="employee"
            render={(value, row) => {
              if (!row.updatedEmployee) return value;
              else {
                return (
                  <Tooltip
                    placement="bottom"
                    title={
                      "Usuário atualizado em " +
                      formatDate(row.dateUpdatedUser, "DD/MM/YYYY")
                    }
                  >
                    <Text mark>{value}</Text>
                  </Tooltip>
                );
              }
            }}
          />
          {login.company.master && (
            <React.Fragment>
              <Table.Column
                width={110}
                title="Empresa"
                dataIndex="companyClient"
                key="companyClient"
              />
              <Table.Column
                width={50}
                align="right"
                title="Taxa"
                dataIndex="fee"
                key="fee"
                render={(value) => <FormatMoney value={value} />}
              />
              <Table.Column
                width={50}
                align="center"
                title="Tipo"
                dataIndex={"corporate"}
                key="corporate"
                filters={[
                  { text: "Corporativo", value: true },
                  { text: "Colaborador", value: false },
                ]}
                onFilter={(value, record) => record.corporate === value}
                defaultFilteredValue={login.company.master ? [false] : null}
                render={(value) => (value ? "Corporativo" : "Colaborador")}
              />
            </React.Fragment>
          )}

          <Table.Column
            width={50}
            align="right"
            title="Valor Solicitado"
            dataIndex="value"
            key="value"
            render={(value) => <FormatMoney value={value} />}
          />
          <Table.Column
            width={50}
            align="right"
            title="Valor Aprovado"
            dataIndex="valueNF"
            key="valueNF"
            render={(value) => <FormatMoney value={value} />}
          />
          <Table.Column
            width={50}
            align="center"
            title="Status"
            dataIndex="status"
            key="status"
            filters={
              login.company.master
                ? _.uniqWith(
                    data.data.map((d) => {
                      return { text: d.status, value: d.status };
                    }),
                    _.isEqual,
                  )
                : null
            }
            defaultFilteredValue={
              login.company.master
                ? [
                    "Validação",
                    "Revisão",
                    "Aprovado",
                    "Confirmado",
                    "Transferindo",
                    "Recebido",
                    "Pagando",
                    "Pago",
                    "Cancelado",
                    "Re-Tentativa",
                  ]
                : null
            }
            onFilter={(value, record) => {
              return login.company.master ? record.status === value : true;
            }}
            render={(value, row) => (
              <Tag color={row.category}>{value.toUpperCase()}</Tag>
            )}
          />
          <Table.Column
            width={50}
            align="center"
            title="Segmentação"
            dataIndex="benefit"
            key="benefit"
          />
          <Table.Column
            width={80}
            align="center"
            title="Opção"
            dataIndex={["option", "name"]}
            key="option.name"
          />
          <Table.Column
            fixed="right"
            width={50}
            align="center"
            title="Ações"
            dataIndex="id"
            key="id"
            render={(value) => (
              <Button
                size="small"
                type={"link"}
                onAuxClick={(e) => window.open("/refund/" + value)}
                onClick={() => navigate(`/refund/${value}`)}
              >
                Detalhes
              </Button>
            )}
          />
        </Table>
      </Content>
      <Footer>
        <Space>
          {!login.company.master && (
            <Button
              type="primary"
              icon={<DollarCircleOutlined />}
              onClick={() => navigate("/solicitation/refund")}
            >
              Fazer Pedido de Pagamento
            </Button>
          )}
          {login.company.master && (
            <Button
              loading={data.loading}
              disabled={data.loading}
              type="primary"
              icon={<CloseCircleOutlined />}
              onClick={onFinishRefunds}
            >
              Recusar Novos
            </Button>
          )}
          {/* {(login.company.master && !batch.data) &&
                        <Button loading={batch.loading} type="primary" icon={<PlusCircleOutlined />} onClick={onOpenBatch}>Abrir Lote</Button>
                    }
                    {(login.company.master && batch.data) &&
                        <Button loading={batch.loading} type="primary" icon={<CloseCircleOutlined />} onClick={onCloseBatch}>Fechar Lote</Button>
                    } */}
        </Space>
      </Footer>
    </Layout>
  );
};

export default connect(mapStateToProps, {})(RefundScreen);
